var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"swiperBlock",staticClass:"project-swiper"},[_c('div',{staticClass:"swipers-content",class:_vm.moveType,style:(("width: " + (100*_vm.contentNumber) + "vw; left: " + _vm.moveX + "px; transform: translateX(" + (-100*_vm.contentIndex) + "vw);"))},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a33f545e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/swiperContent.vue
// module id = null
// module chunks = 